
interface Period {
  years: string;
  position: string;
  focus: string;
  actions: string[];
  tags: string[];
  epochTitle: string;
  globalIndex: number;
}

interface TimelineItemProps {
  period: Period;
  index: number;
  isActive: boolean;
  isVisible: boolean;
  isLeft: boolean;
  onClick: () => void;
}

export default function TimelineItem({ 
  period, 
  index, 
  isActive, 
  isVisible, 
  isLeft, 
  onClick 
}: TimelineItemProps) {
  return (
    <div 
      className={`relative flex items-center mb-16 transition-all duration-700 ${
        isLeft ? 'justify-end pr-8' : 'justify-start pl-8'
      }`}
      data-timeline-item
    >
      {/* 時間軸節點 */}
      <div 
        className={`absolute left-1/2 transform -translate-x-1/2 w-6 h-6 rounded-full border-4 transition-all duration-500 cursor-pointer z-10 ${
          isActive 
            ? 'scale-150 shadow-lg' 
            : isVisible 
            ? 'scale-125' 
            : 'scale-100'
        }`}
        style={{
          backgroundColor: isActive ? '#D4C4B0' : '#E8E4E0',
          borderColor: isActive ? '#8B7D6B' : '#C4B5A0',
          boxShadow: isActive ? '0 0 20px rgba(139, 125, 107, 0.6)' : 'none'
        }}
        onClick={onClick}
      ></div>

      {/* 內容卡片 */}
      <div 
        className={`w-5/12 p-6 rounded-2xl shadow-lg cursor-pointer transition-all duration-700 transform ${
          isActive 
            ? 'scale-105 shadow-2xl' 
            : isVisible 
            ? 'scale-102 shadow-xl' 
            : 'scale-100'
        } ${
          isLeft ? 'mr-8' : 'ml-8'
        }`}
        style={{
          backgroundColor: isActive ? '#E8E4E0' : '#F5F3F0',
          boxShadow: isActive 
            ? '0 20px 40px rgba(139, 125, 107, 0.3)' 
            : '0 10px 30px rgba(180, 165, 150, 0.2)',
          filter: isActive ? 'brightness(1.05)' : 'brightness(1)'
        }}
        onClick={onClick}
      >
        {/* 年份標籤 */}
        <div 
          className="inline-block px-4 py-2 rounded-full text-sm font-bold mb-4"
          style={{
            backgroundColor: isActive ? '#D4C4B0' : '#C4B5A0',
            color: isActive ? '#5D4E37' : '#8B7D6B'
          }}
        >
          {period.years}
        </div>

        {/* 職位 */}
        <h3 
          className="text-xl font-bold mb-3 leading-tight"
          style={{ color: isActive ? '#5D4E37' : '#8B7D6B' }}
        >
          {period.position}
        </h3>

        {/* 重點領域 */}
        <p 
          className="text-base mb-4 leading-relaxed"
          style={{ color: isActive ? '#6B5B4F' : '#A69B8A' }}
        >
          {period.focus}
        </p>

        {/* 標籤 */}
        <div className="flex flex-wrap gap-2">
          {period.tags.slice(0, 2).map((tag, tagIndex) => (
            <span
              key={tagIndex}
              className="px-3 py-1 rounded-full text-xs font-medium"
              style={{
                backgroundColor: isActive ? '#C4B5A0' : '#D4C4B0',
                color: isActive ? '#5D4E37' : '#8B7D6B'
              }}
            >
              {tag}
            </span>
          ))}
          {period.tags.length > 2 && (
            <span
              className="px-3 py-1 rounded-full text-xs font-medium"
              style={{
                backgroundColor: isActive ? '#C4B5A0' : '#D4C4B0',
                color: isActive ? '#5D4E37' : '#8B7D6B'
              }}
            >
              +{period.tags.length - 2}
            </span>
          )}
        </div>

        {/* 發光效果 */}
        {isActive && (
          <div 
            className="absolute inset-0 rounded-2xl pointer-events-none"
            style={{
              background: 'linear-gradient(45deg, rgba(212, 196, 176, 0.3), rgba(139, 125, 107, 0.2))',
              filter: 'blur(1px)'
            }}
          ></div>
        )}
      </div>

      {/* 連接線 */}
      <div 
        className={`absolute top-1/2 w-8 h-0.5 transition-all duration-500 ${
          isLeft ? 'right-6' : 'left-6'
        }`}
        style={{
          backgroundColor: isActive ? '#8B7D6B' : '#C4B5A0',
          opacity: isActive ? 1 : 0.6
        }}
      ></div>
    </div>
  );
}
